module.exports = __webpack_public_path__ + "static/media/48234037_2308766715865173_8982457301063434240_o-thumb.d74e40d6.jpg";